import { createMergeReducer } from '../utils/reducer'
import { CollectionDetail } from './collections'

export type TitleIdToCarousel = {
  [titleId: string]: CollectionDetail[] | undefined
}

export const reducer = createMergeReducer(
  t => t.carousel,
  {} as TitleIdToCarousel
)
